<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{
          edit
            ? `Edit Programme Application Schedule`
            : "Add Programme Application Schedule"
        }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="12">
            <v-select
              v-model.trim="form.program_id"
              :items="programs"
              :item-text="
                (program) =>
                  `${program.degree?.short_name || ''}  ${
                    program.specialization ? ' - ' : ''
                  } ${program.specialization || ''}`
              "
              item-value="id"
              label="Programme*"
              hide-selected
              outlined
              dense
              :rules="[rules.required]"
              hide-details="auto"
            ></v-select>
          </v-col>
          <v-col cols="6"
            ><v-autocomplete
              v-model.trim="form.year"
              label="Year*"
              outlined
              dense
              :items="years"
              :rules="[rules.required]"
              hide-details="auto"
          /></v-col>
          <v-col cols="6"
            ><v-select
              v-model.trim="form.batch"
              label="Batch*"
              :items="[1, 2]"
              hide-selected
              outlined
              dense
              :rules="[rules.required]"
              hide-details="auto"
          /></v-col>
          <v-col cols="6">
            <v-menu
              v-model="showStartDatePicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="form.start_date"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  label="Start Date*"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[rules.required]"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.start_date"
                :min="minDate"
                @input="showStartDatePicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <v-menu
              v-model="showEndDatePicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="form.end_date"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  label="End Date*"
                  outlined
                  dense
                  hide-details="auto"
                  :disabled="!form.start_date"
                  :rules="[rules.required]"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.end_date"
                :min="form.start_date"
                @input="trackDateChange(), (showEndDatePicker = false)"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <v-menu
              v-model="showCourseStartDatePicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="form.course_start_date"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  label="Course Start Date*"
                  :disabled="!form.start_date && !form.end_date"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[rules.required]"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.course_start_date"
                :min="form.end_date"
                @input="showCourseStartDatePicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">{{
          edit ? "Update" : "Save"
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    program_application: {
      type: Object,
      default: () => {},
    },
    programs: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {},
  data() {
    return {
      rules,
      form: {},
      showCourseStartDatePicker: false,
      showStartDatePicker: false,
      showEndDatePicker: false,
      years: Array.from({ length: 15 }, (v, k) => k + new Date().getFullYear()),
    };
  },
  computed: {
    minDate() {
      return this.currentDate(new Date());
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      if (this.edit) {
        this.form = { ...this.program_application };
      }
    },

    save() {
      if (!this.$refs.form.validate()) return;

      if (this.edit) {
        this.$emit("update", this.form);
      } else {
        this.form.active = true;
        this.$emit("create", this.form);
      }
    },
    currentDate(date) {
      const d = new Date(date);
      let month = "" + (d.getMonth() + 1);
      let day = "" + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    trackDateChange() {
      if (this.form.start_date > this.form.end_date) {
        this.form.end_date = "";
      }
    },
  },
};
</script>

<style scoped></style>
